import { useGraphQLQuery } from '@betterment/graphql';
import { Route, Routes, useSearchParams } from 'react-router-dom';

import { ConfirmAccount } from './components/ConfirmAccount';
import { Error } from './components/Error';
import { Loading } from './components/Loading';
import {
  AdvisedSoloPlanInvitationDocument,
  AdvisedSoloPlanInvitationQuery,
} from './graphql/query.advisedSoloPlanInvitation.generated';

import { WithLayout } from '../RetailApp/components/WithLayout';

export default function Controller() {
  const [params] = useSearchParams();
  const { data, loading, error } = useGraphQLQuery<AdvisedSoloPlanInvitationQuery>(AdvisedSoloPlanInvitationDocument, {
    variables: { token: params.get('invitation_token') },
  });

  if (loading) {
    return <Loading />;
  }

  if (error || !data?.advisedSoloFourOhOneKClientInvite) {
    return <Error />;
  }

  return (
    <WithLayout parts={{ footer: true, sidebar: false }}>
      <Routes>
        <Route
          path="/confirm_account"
          element={<ConfirmAccount logoUrl={data.advisedSoloFourOhOneKClientInvite.advisor.logo?.light} />}
        />
      </Routes>
    </WithLayout>
  );
}
